import Axios from "axios";
import getCsrfToken from "./getCsrfToken";

const [csrfToken, csrfTokenHeaderKey] = getCsrfToken();
const axiosInstance = Axios.create({ headers: { [csrfTokenHeaderKey]: csrfToken } });

export default axiosInstance;
